export const getters = {
  getClaims: state => (appType) => {
    return state.claims[appType];
  },
  getCurrentClaim: (state) => {
    return state.claim;
  },
  getAllClaims: state => {
    return state.claims;
  },
  getICClaimId: (state) => {
    return state.claim?.ua_icclaimid;
  },
};
